// extracted by mini-css-extract-plugin
export var cardContainer = "_pk-0";
export var cardHeader = "_pk-2";
export var collapsedState = "_pk-3";
export var dragHandle = "_pk-5";
export var dragHandleIcon = "_pk-6";
export var dragging = "_pk-1";
export var titleArea = "_pk-4";